import { StepperProps } from '@interfaces/Utils';
import React from 'react';

const useStepper = ({ steps }: StepperProps) => {
    const [activeStep, setActiveStep] = React.useState(0);
    const [completed, setCompleted] = React.useState<{
        [k: number]: boolean;
    }>({ 0: true });

    const totalSteps = () => {
        return steps.length;
    };

    const completedSteps = () => {
        return Object.keys(completed).length;
    };

    const isLastStep = () => {
        return activeStep === totalSteps() - 1;
    };

    const allStepsCompleted = () => {
        return completedSteps() === totalSteps();
    };

    const goToStep = (step: number) => {
        setActiveStep(step);
    };

    const handleNext = () => {
        const newActiveStep =
            isLastStep() && !allStepsCompleted() ?
                // find the first step that has been completed
                steps.findIndex((step: any, i) => !(i in completed)) :
                activeStep + 1;
        setActiveStep(newActiveStep);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStep = (step: number) => () => {
        setActiveStep(step);
    };

    const handleComplete = () => {
        const newCompleted = completed;
        newCompleted[activeStep] = true;
        setCompleted(newCompleted);
        handleNext();
    };

    const handleBackComplete = () => {
        const newCompleted = completed;
        newCompleted[activeStep - 1] = false;
        setCompleted(newCompleted);
        handleBack();
    };

    const handleReset = () => {
        setActiveStep(0);
        setCompleted({});
    };

    return {
        completed,
        activeStep,
        totalSteps,
        completedSteps,
        isLastStep,
        allStepsCompleted,
        handleNext,
        handleBack,
        handleStep,
        handleComplete,
        handleBackComplete,
        handleReset,
        goToStep,
    };
};

export { useStepper };
